<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.876 12.0025L7.16062 15.7178C6.85141 16.0271 6.85141 16.5292 7.16062 16.8384C7.46984 17.1476 7.97193 17.1476 8.28114 16.8384L11.9965 13.1231L15.7118 16.8384C16.0211 17.1476 16.5231 17.1476 16.8324 16.8384C17.1416 16.5292 17.1416 16.0271 16.8324 15.7178L13.117 12.0025L16.8324 8.28719C17.1416 7.97797 17.1416 7.47588 16.8324 7.16667C16.5231 6.85745 16.0211 6.85745 15.7118 7.16667L11.9965 10.882L8.28114 7.16667C7.97193 6.85745 7.46984 6.85745 7.16062 7.16667C6.85141 7.47588 6.85141 7.97797 7.16062 8.28719L10.876 12.0025Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Times'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
